import queryString from "query-string";
import catalogContexts from "@utils/constants/catalogContexts";

const mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX_V2;

export default function initializeUiStateForListingPage(uiState, listingPage, context) {
  const {
    availabilities: availabilitiesLP,
    kinds: kindsLP,
    category: categoriesLP,
    clothes: clothesLP,
    accessories: accessoriesLP,
    subcategory: subcategoryLP,
    product_collections: productCollectionsLP,
    colors: colorsLP,
    seasons: seasonLP,
    sleeves: sleevesLP,
    legs: legsLP,
    brands: brandLP,
  } = listingPage ? queryString.parse(listingPage.search_query, { arrayFormat: "bracket" }) : {};

  const categoryLP = [...(categoriesLP || []), ...(clothesLP || []), ...(accessoriesLP || [])];

  uiState[mainIndex].refinementList.catalogs =
    context === catalogContexts.swap ? ["In Swap"] : ["In Sales"];

  uiState[mainIndex].refinementList.in_stock =
    availabilitiesLP === "all" ? ["false", "true"] : ["true"];

  uiState[mainIndex].refinementList.segment = kindsLP || [];
  uiState[mainIndex].refinementList.collections = productCollectionsLP || [];
  uiState[mainIndex].refinementList.category = categoryLP || [];
  uiState[mainIndex].refinementList.subcategory = subcategoryLP || [];
  uiState[mainIndex].refinementList.colors = colorsLP || [];
  uiState[mainIndex].refinementList.season = seasonLP || [];
  uiState[mainIndex].refinementList.sleeves = sleevesLP || [];
  uiState[mainIndex].refinementList.legs = legsLP || [];
  uiState[mainIndex].refinementList["brand.name"] = brandLP || [];

  for (let [key, value] of Object.entries(uiState[mainIndex].refinementList)) {
    if (!value || value?.length === 0) delete uiState[mainIndex].refinementList[key];
  }

  return uiState;
}
